import { render, staticRenderFns } from "./IdcCreateNewContract.vue?vue&type=template&id=5cadd5c1&scoped=true&"
import script from "./IdcCreateNewContract.vue?vue&type=script&lang=js&"
export * from "./IdcCreateNewContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cadd5c1",
  null
  
)

export default component.exports